export default __webpack_public_path__ + "static/media/mobileWef6.934e73bc.png";